import { gold } from "@ant-design/colors"
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal, Space } from "antd"
import { CSSProperties } from "react"
import VSpace from "../../../../common/VSpace"
import { centsToDollarsDisplay } from "../../../../displayFormatters"
import { FinalPriceChangesOnNotApproved } from "../../List/workareaGroupsListModel"

type Props = {
  isOpen: boolean
  onCancel: () => void
  onConfirm: (keepFinalPrices: boolean) => void
  finalPriceChanges: FinalPriceChangesOnNotApproved[]
}

const FinalPriceWarningsModal = ({ isOpen, onCancel, onConfirm, finalPriceChanges }: Props) => {
  if (finalPriceChanges.length < 1) {
    return null
  }

  return <Modal
    title={<Space><FontAwesomeIcon icon={faInfoCircle} color={gold.primary} /><strong>Final Price Warnings</strong></Space>}
    width={600}
    footer={[
      <Button key="cancel" onClick={onCancel}>Cancel</Button>,
      <Button key="reset" onClick={() => onConfirm(false)}>Reset to estimated</Button>,
      <Button key="keep" type="primary" onClick={() => onConfirm(true)}>Keep final prices</Button>
    ]}
    open={isOpen}
    onCancel={onCancel}
  >
    <VSpace>
      <span>Some workareas in this group have a final price which does not match the estimated price:</span>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th style={leftStyle}>Workarea</th>
            <th style={rightStyle}>Estimated</th>
            <th style={rightStyle}>Final</th>
          </tr>
        </thead>
        <tbody>
          {finalPriceChanges.map((x) => <tr key={x.workareaId}>
            <td style={leftStyle}>{x.workareaName}</td>
            <td style={rightStyle}>{centsToDollarsDisplay(x.estimatedPrice)}</td>
            <td style={rightStyle}>{centsToDollarsDisplay(x.currentQuotedPrice)}</td>
          </tr>)}
        </tbody>
      </table>
      <span>Do you want to reset to the estimated prices or keep the final prices?</span>
    </VSpace>
  </Modal>
}

export default FinalPriceWarningsModal

const leftStyle: CSSProperties = { textAlign: 'left' }
const rightStyle: CSSProperties = { textAlign: 'right', padding: '0 10px' }